/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import 'chartjs-adapter-moment';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export function LineChart({ data, options, height = 0, ...chartProps }) {
  return (
    <div className="chart-container">
      {height ? (
        <Line data={data} options={options} height={height} {...chartProps} />
      ) : (
        <Line data={data} options={options} {...chartProps} />
      )}
    </div>
  );
}

export default LineChart;
